// extracted by mini-css-extract-plugin
export default {"barcode":"Barcode_barcode__vUtLO","popup":"Barcode_popup__qipjf","fadeInOut":"Barcode_fadeInOut__1nkli"};